import React, { Component } from 'react';
import './../css/Actividad.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { faHome, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons"; 
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Col, Row, Container } from 'react-bootstrap';
import enviar from './../../img/svg/Enviar(blanco).svg';
import Swal from 'sweetalert2'

const API_URL = process.env.REACT_APP_API_URL;
export class Nueva_actividad extends Component {
    static displayName = Nueva_actividad.name;

    constructor(props) {
        super(props);
        this.state = {
            actividades: [], busqueda: "", actividad: {
                idactividad: 0, actividad: "", tipoactividad: 0, descripcion: "", idtipoactividad: "", numhoras: 0,
                anio: "", termino: "", termino1: false, termino2: false, termino3: false, periodicidad: "", totalhoras: 0, estadocheck: "", escarga: ""
            }, termino: "", observacion: "", pao1: "", pao2: "", pae: "", accion: "", loading: false, abierto: false,
            selectidact: "", selectact: "", observacion: "", periodo: "", anio: "", actividades_combo: [], actividades: [], tipoactividad: "",
            ambito: ''
        };

        this.onChange = this.onChange.bind(this);
        this.onChangePao = this.onChangePao.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.populateActividadesCombo = this.populateActividadesCombo.bind(this);
        this.handleNew = this.handleNew.bind(this);
    }

    componentDidMount() {
        let tipo = this.props.tipoactividad
        let tipoact = ""
        let consulta = ''
        if (tipo === 'A|R') {
            tipoact = 'Docencia Grado'
            consulta = 'R'
        } else if (tipo === 'A|P') {
            tipoact = 'Docencia PostGrado'
            consulta = 'R'
        } else if (tipo === 'A|I') {
            tipoact = 'Investigación'
            consulta = 'I'
        } else if (tipo === 'A|V') {
            tipoact = 'Vinculación'
            consulta = 'V'
        } else if (tipo === 'A|G') {
            tipoact = 'Gestión Académica'
            consulta = 'A'
        } else {
            tipoact = 'Seleccionar Ámbito'
            consulta = 'R'
        }
        this.setState({
            actividades: this.props.actividades_combo,
            actividades_combo: this.props.actividades_combo,
            abierto: this.props.abierto,
            tipoactividad: tipo

        })

        this.populateActividadesCombo(consulta)
        //console.log(this.state.termino)
    }



    handleChange(e) {
        var idactividad = e.target.value;
        var data = this.state.actividades_combo.filter(x => x.idactividad == idactividad).map(act => act.descripcion);

        this.setState({ selectact: data, selectidact: e.target.value });
    }

    //handleSearch(event) {
    //    this.setState({ observacion: event.target.value.toUpperCase() });
    //    //console.log(this.state.observacion);
    //}


    handleSearch(event) {
        var control = event.target.name;
        if (control === "txObservacion") {
            var value = this.state.observacion;
            value = event.target.value.toUpperCase();
            this.setState({
                observacion: value
            });
        }
        //this.props.updatestate_mat(this.props.idcurso, this.state.observacion, this.state.termino, this.state.accion)
    }


    onChange(event) {
        let tipo = event.target.value
        let tipoact = ''
        let consulta = ''
        if (tipo === 'A|R') {
            tipoact = 'Docencia Grado'
            consulta = 'R'
        } else if (tipo === 'A|P') {
            tipoact = 'Docencia PostGrado'
            consulta = 'R'
        } else if (tipo === 'A|I') {
            tipoact = 'Investigación'
            consulta = 'I'
        } else if (tipo === 'A|V') {
            tipoact = 'Vinculación'
            consulta = 'V'
        } else if (tipo === 'A|G') {
            tipoact = 'Gestión Académica'
            consulta = 'A'
        } else {
            tipoact = 'Seleccionar Ámbito'
        }


        this.setState({
            ambito: consulta,
            tipoactividad: tipo
        })
        this.populateActividadesCombo(consulta)
    }

    onChangePao(event) {
        //console.log('CLICK EN->' + event.target.value)
        //console.log('ESTADO DE Checked->' + event.target.checked)
        if (event.target.value == 1) {
            this.setState({
                termino1: event.target.checked ? true : false
            })
        }

        if (event.target.value == 2) {
            this.setState({
                termino2: event.target.checked ? true : false
            })
        }

        if (event.target.value == 0) {
            this.setState({
                termino3: event.target.checked ? true : false
            })
        }

    }

    //por programar
    handleNew(e) {
        //console.log("observacion: ", this.state.observacion.trim());
        //console.log("selectidact: ", this.state.selectidact);

        //console.log("termino1: ", this.state.termino1);
        //console.log("termino2: ", this.state.termino2);
        //console.log("termino2: ", this.state.termino3);

        if (this.state.observacion.trim() != "" && this.state.selectidact != "" && (this.state.termino1 || this.state.termino2||this.state.termino3)) {
            let d1 = this.state.termino1 ? 'PAO ' + this.props.anio + '-1' : '';
            let d2 = this.state.termino2 ? 'PAO ' + this.props.anio + '-2' : '';
            let d3 = this.state.termino3 ? 'PAE ' + this.props.anio : '';
            let termino = d3 + ' ' + d1 + ' ' + d2;
            this.props.updatestate(-1, this.state.selectidact, this.state.selectact, '', this.props.anio, termino, this.state.tipoactividad, this.state.observacion, termino, termino, termino, 'Nueva Carga');
            
            //console.log('NUEVOOO' + '|' + this.state.selectidact + '|' + this.state.selectact + '|' + this.props.anio + '|' + this.state.periodo + 'A|V' + this.state.observacion + '|' + termino + '|' + termino + '|' + termino + '|' + 'Nueva Carga')
            this.props.toggle();
            Swal.fire({
                title: 'Hecho!',
                text: 'Actividad agregada exitosamente',
                icon: 'success',
                timer: 1500,
                confirmButtonText: 'Ok'
            });
            this.setState({ selectidact: "", periodo: "", observacion: "", termino1: false, termino2: false, termino3: false});
        } else {
            Swal.fire({
                title: 'ERROR!',
                text: 'Debes llenar todo los campos solicitados',
                icon: 'error',
                timer: 1500,
                confirmButtonText: 'Ok'
            });
        } 
    }
     

    handlkeyPress(evento) {
        // console.log(String.fromCharCode(event.keyCode));
        let tecla = evento.which;
        let caracter = String.fromCharCode(tecla)
        let regex = new RegExp("^[A-Za-z0-9 ,.]+$");


        if (!regex.test(caracter)) {

            Swal.fire({
                title: 'Lo sentimos!',
                text: 'El campo de observación no permite caracteres especiales.',
                icon: 'error',
                timer: 1500,
                confirmButtonText: 'Ok'
            })

            return false;
        }

    }

    render() {

        const combo = {
            width: '150px',
        };
        const estilo = {
            color: 'white',
            fontSize: '15px',
            marginBottom: '20px',
            fontFamily: 'Robota'
        };

        const form_nuevo = {
            fontSize: '0.65em',
            color: "darkgray"
        };
       // console.log(this.props)
        return (
            <div> 
                    <Modal isOpen={this.props.abierto}>
                        <ModalHeader className="modal-header">
                            <label style={estilo}> NUEVO REGISTRO </label>
                        </ModalHeader>
                        <ModalBody>

                            <Container className="fuente-modal" fluid>
                                <Row>
                                    <Col md="4">
                                    <span>Ámbito<label className="asterisco">*</label></span><br />
                                    <select name="ambitos" value={this.state.tipoactividad} onChange={this.onChange}>
                                        <option value="S|N">Seleccione un ámbito</option>
                                        <option value="A|R">Docencia Grado</option>
                                        <option value="A|P">Docencia PostGrado</option>
                                        <option value="A|I">Investigación</option>
                                        <option value="A|V">Vinculación</option>
                                        <option value="A|G">Gestión Académica</option>
                                        </select>

                                    </Col>
                                    <Col md="6">
                                    <span>Actividad<label className="asterisco">*</label></span><br />

                                        <select style={combo} onChange={this.handleChange}>
                                            <option key="0" value="0" title="">Seleccione una actividad...</option>
                                            {this.state.actividades_combo.map(actividad =>
                                                <option key={actividad.idactividad} value={actividad.idactividad} title={actividad.descripcion.toLowerCase().charAt(0).toUpperCase() + actividad.descripcion.toLowerCase().slice(1)}>
                                                    {actividad.descripcion.length > 55 ? `${actividad.descripcion.substring(0, 55).toLowerCase().charAt(0).toUpperCase() + actividad.descripcion.substring(0, 55).toLowerCase().slice(1)}...` : actividad.descripcion.toLowerCase().charAt(0).toUpperCase() + actividad.descripcion.substring(0, 55).toLowerCase().slice(1)}
                                                </option>

                                            )}
                                        </select>
                                    </Col>
                                    <Col md="2">
                                    <div>
                                        <span>Periodo<label className="asterisco">*</label></span><br />
                                        {(this.props.terminoPeriodo === "0S" || this.props.terminoPeriodo === "1S") && (
                                            <div>
                                                <input type="checkbox" className="form-radio" name="radio" id="checkpae" value="0" onChange={this.onChangePao} />
                                                <label className="form-check-label" htmlFor="checkpae">PAE</label>
                                            </div>
                                        )}
                                        {(this.props.terminoPeriodo === "0S" || this.props.terminoPeriodo === "1S") && (
                                            <div>
                                                <input type="checkbox" className="form-radio" name="radio" id="checkpao1" value="1" onChange={this.onChangePao} />
                                                <label className="form-check-label" htmlFor="checkpao1">PAO-1</label>
                                            </div>
                                        )}
                                        <div>
                                            <input type="checkbox" className="form-radio" name="radio" id="checkpao2" value="2" onChange={this.onChangePao} />
                                            <label className="form-check-label" htmlFor="checkpao2">PAO-2</label>
                                        </div>
                                        {/*<div onChange={this.onChangePao}>*/}
                                        {/*    <input type="checkbox" className="form-radio" name="radio" value="0" disabled={this.props.terminoPeriodo} />PAE*/}
                                        {/*    <input type="checkbox" className="form-radio" name="radio" value="1" disabled={this.props.terminoPeriodo} />PAO-1*/}
                                        {/*    <input type="checkbox" className="form-radio" name="radio" value="2" />PAO-2*/}
                                        {/*</div>*/}
                                    </div>
                                </Col>
                                </Row>


                                <Row>
                                    <Col md="12">
                                    <span>Observación<label className="asterisco">*</label></span><br />
                                    <textarea id="txObservacion" name="txObservacion" className="form-allwidth" onKeyPress={this.handlkeyPress} className='area_width' value={this.state.observacion} onChange={this.handleSearch} required></textarea>
                                    </Col>
                                </Row>
                            </Container>

                        </ModalBody>
                        <ModalFooter>
                            <button className="btn btn-info btn-round" onClick={() => this.handleNew()}>Agregar</button>
                        <button className="btn btn-success btn-round" onClick={() => this.props.toggle()}>Cancelar</button>
                        </ModalFooter>
                    </Modal>



                 
            </div>
        );
    }

    async populateActividadesCombo(ambito) {
        const response = await fetch(API_URL + 'TblActividades/' + this.props.anio + '/'+ambito+'/token');
        const respuesta = await response.json();
        const data = respuesta;
        this.setState({ actividades_combo: data, loading: false });
    }


}
